"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const string_utils_1 = require("@/common/string_utils");
function default_1() {
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const deliveries = (0, react_redux_1.useSelector)((state) => state.roomData.deliveries);
    const fixedDeliveries = (0, react_redux_1.useSelector)((state) => state.fixedDeliveries); // 1
    const diffDeliveries = (0, react_redux_1.useSelector)((state) => state.diffDeliveries); // 3
    const conditionalDeliveries = (0, react_redux_1.useSelector)((state) => state.conditionalDeliveries); // 4
    const additionalDeliveries = (0, react_redux_1.useSelector)((state) => state.additionalDeliveries); // 5
    const { t } = (0, react_i18next_1.useTranslation)();
    const generateDeliveryInfo = (type) => {
        var _a, _b, _c;
        let targetInfos = [];
        if (isPreview) {
            switch (type) {
                case '1':
                    targetInfos = fixedDeliveries;
                    break;
                case '4':
                    targetInfos = conditionalDeliveries;
                    break;
                case '3':
                    targetInfos = diffDeliveries;
                    break;
            }
        }
        else {
            targetInfos = deliveries.filter(obj => obj.delivery_type === Number(type));
        }
        switch (type) {
            case '2': // ? 무료
                return (0, jsx_runtime_1.jsx)("div", { children: `  •  ${t('무료 배송')}` });
            case '1': // ? 고정
                return ((0, jsx_runtime_1.jsx)("div", { children: `  •  ${t('배송비')} ${(0, string_utils_1.money)(((_a = targetInfos[0]) === null || _a === void 0 ? void 0 : _a.delivery_price) || 0)}${t('원')}` }));
            case '4': // ? 조건부
                return ((0, jsx_runtime_1.jsx)("div", { children: `  •  ${t('배송비')} ${(0, string_utils_1.money)(((_b = targetInfos[0]) === null || _b === void 0 ? void 0 : _b.delivery_price) || 0)}${t('원')}(${t('price원 이상 구매 시 무료', { price: (0, string_utils_1.money)(((_c = targetInfos[0]) === null || _c === void 0 ? void 0 : _c.number) || 0) })})` }));
            case '3': // ? 구매개수별 차등
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle5 gray-80" }, { children: t('배송비') })), targetInfos.map((obj, idx) => {
                            var _a;
                            const { number: condition, delivery_price } = obj;
                            const nextCondition = (_a = targetInfos[idx + 1]) === null || _a === void 0 ? void 0 : _a.number;
                            const isNextConditionOneMore = Number(condition) + 1 === nextCondition;
                            const isNextConditionSameOrSmall = Number(condition) >= Number(nextCondition);
                            const isLastCondition = !nextCondition;
                            return ((0, jsx_runtime_1.jsx)("div", { children: `  •  ${isNextConditionOneMore || isNextConditionSameOrSmall
                                    ? `${condition}${t('개')}`
                                    : isLastCondition
                                        ? `${t('quantity개 이상', { quantity: condition })}`
                                        : `${condition}${t('개')}~${nextCondition - 1}${t('개')}`}: ${(0, string_utils_1.money)(delivery_price || 0)}${t('원')}` }, `differential_infos_${condition}_${delivery_price}_${idx}`));
                        })] }));
        }
    };
    // ? JIMA: Jeju/Island/Mountainous Areas
    const generateJIMAFeeInfo = () => {
        var _a, _b;
        const additionalFee = (isPreview
            ? (_a = additionalDeliveries[0]) === null || _a === void 0 ? void 0 : _a.delivery_price
            : (_b = deliveries.find(delivery => delivery.delivery_type === 5)) === null || _b === void 0 ? void 0 : _b.delivery_price) || 0;
        if (additionalFee)
            return ((0, jsx_runtime_1.jsx)("div", { children: `  •  ${t('제주/도서산간 추가 배송비')}: ${(0, string_utils_1.money)(additionalFee)}${t('원')}` }));
        else
            return (0, jsx_runtime_1.jsx)("div", { children: `  •  ${t('제주/도서산간은 추가배송비가 발생될 수 있어요.')}` });
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "caption1 gray-60", css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '4px',
            padding: '0 16px',
            whiteSpace: 'pre-wrap',
        } }, { children: [generateDeliveryInfo(deliveryType), generateJIMAFeeInfo()] })));
}
exports.default = default_1;
